import type React from 'react';
import toast from 'react-hot-toast';
import ClipLoader from 'react-spinners/ClipLoader';

export type LoadingToastOptions = {
  message: string;
  duration?: number;
  icon?: React.ReactElement;
};

export const useShowLoadingToast = ({
  message,
  duration = Number.POSITIVE_INFINITY,
}: LoadingToastOptions): string => {
  return toast.loading(message, {
    duration,
    icon: <ClipLoader color="var(--primaryColor)" size={20} />,
  });
};
